export default __webpack_public_path__ + "static/media/Web_600x500px.b09b0f10.png";